import { I18n } from "@assets/strings";
import React, { useState } from "react";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { Media } from "@domain/media/media";
import { useAsync } from "@utils/hooks";
import { ClosableModal } from "@ui/modals/closableModal";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { SimpleTextInput } from "@ui/components/inputs/simpleTextInput";
import { stack } from "@ui/components/layout";

interface AssetEditModalProps extends React.HTMLAttributes<HTMLDivElement> {
	asset: Media;
	close: () => void;
}
export const AssetEditModal: React.FC<AssetEditModalProps> = ({ asset, close, ...htmlProps }) => {
	const { mediaService } = useServices();
	const [name, setName] = useState(asset.displayName);
	const { run, loading } = useAsync(async () => {
		await mediaService.edit(asset.id, name);
		close();
	}, [asset, name]);

	return (
		<Container {...htmlProps} close={close}>
			<PrimaryMedium>{I18n.t("workspace.assets.name.label")}</PrimaryMedium>
			<SimpleTextInput value={name} onChange={setName} />
			<LoadingButton loading={loading} onClick={run} disabled={!name}>
				{I18n.t("validate")}
			</LoadingButton>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	${stack(12, "flex-start", "stretch")};
`;
